"use client"

import Image from "next/image"

export default function CourseHero() {
  return (
    <section
      className="relative min-h-screen flex items-center justify-center overflow-hidden pt-20"
      style={{ backgroundColor: "#020617" }}
    >
      {/* Background Grid Pattern */}
      <div className="absolute inset-0 opacity-10">
        <div
          className="absolute inset-0"
          style={{
            backgroundImage: "radial-gradient(circle at 2px 2px, rgba(0, 158, 61, 0.3) 1px, transparent 0)",
            backgroundSize: "50px 50px",
          }}
        />
      </div>

      {/* Additional background gradients for depth */}
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_50%_0%,rgba(0,158,61,0.15),transparent_50%)]"></div>
      <div className="absolute bottom-0 left-0 w-full h-32 bg-gradient-to-t from-slate-950/50 to-transparent"></div>

      <div className="container px-4 sm:px-6 mx-auto relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-20 items-center">
          {/* Left Content */}
          <div className="space-y-6 text-center lg:text-left">
            {/* Maven Logo and Title together */}
            <div className="space-y-1">
              <div className="flex justify-center lg:justify-start">
                <Image
                  src="/course/maven-logo.png"
                  alt="Maven"
                  width={150}
                  height={80}
                  className="object-contain w-auto h-8 sm:h-10 lg:h-12"
                />
              </div>

              <h1 className="text-4xl sm:text-5xl lg:text-6xl font-montserrat font-bold leading-tight">
                <span style={{ color: "#FFFFFF" }}>Master </span>
                <span style={{ color: "#009E3D" }}>Enterprise</span>
                <br />
                <span style={{ color: "#009E3D" }}>AI Agent</span>
                <br />
                <span style={{ color: "#FFFFFF" }}>Engineering</span>
              </h1>
            </div>

            <p className="text-lg sm:text-xl md:text-2xl font-vietnam" style={{ color: "#FFFFFF", opacity: 0.8 }}>
              From React Patterns to Multi-Agent Systems. Build production-grade AI agents with hands-on guidance.
            </p>

            <div>
              <a
                href="https://maven.com/rakeshgohel/ai-agent-engineering-react-rag-multi-agent/"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-3 font-vietnam font-semibold px-8 py-4 rounded-lg transition-all duration-300 transform hover:scale-105 text-lg shadow-lg hover:shadow-green-500/25"
                style={{
                  backgroundColor: "#009E3D",
                  color: "#020617",
                  boxShadow: "0 0 20px rgba(0, 158, 61, 0.3)",
                }}
              >
                Enroll now
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14 5l7 7m0 0l-7 7m7-7H3" />
                </svg>
              </a>
            </div>
          </div>

          {/* Right Content - Laptop Image */}
          <div className="relative w-full max-w-md lg:max-w-none mx-auto">
            {/* Glow effect behind laptop */}
            <div className="absolute inset-0 bg-gradient-radial from-green-500/20 via-green-500/10 to-transparent blur-3xl transform scale-150"></div>

            <div className="relative transform hover:scale-105 transition-transform duration-700">
              <Image
                src="/course/laptop-hero.webp"
                alt="Course Preview"
                width={600}
                height={400}
                className="object-contain drop-shadow-2xl w-full h-auto"
                style={{ filter: "drop-shadow(0 0 50px rgba(0, 158, 61, 0.3))" }}
                priority
              />
            </div>
          </div>
        </div>

        {/* Previously at section */}
        <div className="mt-24 text-center">
          <p className="text-lg font-vietnam mb-8" style={{ color: "#FFFFFF", opacity: 0.6 }}>
            Previously at
          </p>
          <div className="flex items-center justify-center gap-8 sm:gap-12 flex-wrap">
            <div className="opacity-40 hover:opacity-60 transition-opacity duration-300">
              <div className="text-xl sm:text-2xl font-bold" style={{ color: "#FFFFFF" }}>
                SAMSUNG
              </div>
            </div>
            <div className="opacity-40 hover:opacity-60 transition-opacity duration-300">
              <div className="text-xl sm:text-2xl font-bold" style={{ color: "#FFFFFF" }}>
                LG
              </div>
            </div>
            <div className="opacity-40 hover:opacity-60 transition-opacity duration-300">
              <div className="text-xl sm:text-2xl font-bold" style={{ color: "#FFFFFF" }}>
                PAYTM
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
